import { Component } from '@angular/core';

@Component({
  selector: 'allas-more-services',
  imports: [],
  template: `
    <div class="bg-gray-100 flex items-center justify-center gap-2 p-4 mb-6">
      <a
        href="/servicios/cotiza-por-whatsapp"
        class="bg-appPrimary-500 text-white text-xs xl:text-sm px-4 py-1 xl:py-2 rounded-md hover:scale-105 transition-transform duration-150"
      >
        MÁS SERVICIOS
      </a>
      <a
        href="/repuestos"
        class="border border-appPrimary-500 text-appPrimary-500 px-4 py-1 xl:py-2 rounded-md text-xs xl:text-sm hover:scale-105 transition-transform duration-150"
      >
        COMIENZA A COMPRAR
      </a>
    </div>
  `,
})
export class MoreServices {}
